module.exports = __webpack_public_path__ + "img/impala.e27a5799.jpg";